import {
  SET_STEP,
  SET_ADDRESS,
  SET_PHONE_NUMBER,
  SET_SKILLS,
  SET_MEMBER_EQUIPMENTS,
  SET_MEMBER_PROFILE,
  SET_ORGANIZATION_STATUSES,
  SET_PRODUCT_TYPES,
  SET_PRODUCT_SUBTYPES,
  SET_ORGANIZATION_DOCUMENTS,
  SET_IDENTIFICATION_TYPES,
  SET_EQUIPMENTS,
  SET_LANGUAGES,
  SET_PRODUCT_SUBTYPES_LOADING,
} from './mutation-types';

export default {
  /**
  * Set the single organization possible statuses list
  * @param {object} state - the vuex state object
  * @param {object} payload - The statuses list
  */
    [SET_ORGANIZATION_STATUSES](state, payload) {
    state.possibleStatuses = payload;
  },

  /**
  * Set the product types list
  * @param {object} state - the vuex state object
  * @param {object} payload - The types list
  */
   [SET_PRODUCT_TYPES](state, payload) {
    state.productTypes = payload;
  },

  /**
  * Set the product subtypes list
  * @param {object} state - the vuex state object
  * @param {object} payload - The subtypes list
  */
   [SET_PRODUCT_SUBTYPES](state, payload) {
    state.productSubtypes = payload;
  },

  /**
   * Set the loading state
   * @param state
   * @param payload
   */
  [SET_PRODUCT_SUBTYPES_LOADING](state, payload) {
    state.loading = payload;
  },

  /**
  * Set the organization documents list
  * @param {object} state - the vuex state object
  * @param {object} payload - The documents list
  */
   [SET_ORGANIZATION_DOCUMENTS](state, payload) {
    state.documents = payload;
  },

  /**
  * Set the identification types list
  * @param {object} state - the vuex state object
  * @param {object} payload - The identification types list
  */
   [SET_IDENTIFICATION_TYPES](state, payload) {
    state.identificationTypes = payload;
  },

  /**
  * Set the equipments list
  * @param {object} state - the vuex state object
  * @param {object} payload - The equipments list
  */
   [SET_EQUIPMENTS](state, payload) {
    state.equipments = payload;
  },

  /**
  * Set the languages list
  * @param {object} state - the vuex state object
  * @param {object} payload - The languages list
  */
   [SET_LANGUAGES](state, payload) {
    state.languages = payload;
  },

  [SET_ADDRESS](state, payload) {
    state.address = payload;
  },

  [SET_STEP](state, payload) {
    state.step = payload;
  },

  [SET_PHONE_NUMBER](state, payload) {
    state.phone = payload;
  },

  [SET_SKILLS](state, payload) {
    state.skills = payload;
  },

  [SET_MEMBER_EQUIPMENTS](state, payload) {
    state.memberEquipment = payload;
  },

  [SET_MEMBER_PROFILE](state, payload) {
    state.profile = payload;
  },
};
